import { createContext, useContext } from "react";

interface ManagerPinContextType {
  managerPin: string | null;
}

export const ManagerPinContext = createContext<ManagerPinContextType>({
  managerPin: null,
});

export const useManagerPin = () => useContext(ManagerPinContext);
